<template>
  <v-form v-model="mainFormValid">
    <ag-company-select
      v-model="internalValue.duplicateCompanyId"
      :rules="$options.rules.duplicateCompanyId"
      :label="$t('company.fields.duplicateCompanyId')"
      :company-list="companyList"
      @input="change"
    />

    <v-text-field
      v-model="internalValue.companyLogin"
      :rules="$options.rules.companyLogin"
      :error-messages="companyLoginErrorMessage"
      :label="$t('company.fields.companyLogin')"
      type="text"
      @input="change"
    />

    <v-text-field
      v-model="internalValue.displayName"
      :rules="$options.rules.displayName"
      :label="$t('company.fields.displayName')"
      type="text"
      @input="change"
    />

    <ag-user-select
      v-model="internalValue.masterContactList"
      :rules="$options.rules.masterContactList"
      :label="$t('company.fields.masterContactList')"
      :user-list="ownerUserList"
      multiple
      @input="change"
    />
  </v-form>
</template>

<script>
import Helpers from 'src/utils/helpers'
import FormRules from 'src/utils/form-rules'
import Repositories from 'src/repositories'

import AgUserSelect from 'src/components/common/AgUserSelect'
import AgCompanySelect from 'src/components/common/AgCompanySelect'

export default {
  name: 'CreateCompanyForm',
  components: {
    AgUserSelect,
    AgCompanySelect,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    forbiddenCompanyList: {
      type: Array,
      default: () => ([]),
    },
  },
  data () {
    return {
      internalValue: null,
      mainFormValid: false,
      ownerUserList: [],
      companyList: [],
    }
  },
  computed: {
    isFormValid () {
      return this.mainFormValid
    },
    companyLoginErrorMessage () {
      return this.forbiddenCompanyList.includes(this.internalValue.companyLogin)
        ? this.$t('error.form.companyExist')
        : null
    },
  },
  watch: {
    value: {
      immediate: true,
      handler (value) {
        this.internalValue = Helpers.clone(value)
        this.$emit('validate', this.isFormValid)
      },
    },
    isFormValid: {
      immediate: true,
      handler () {
        this.$emit('validate', this.isFormValid)
      },
    },
  },
  async mounted () {
    const [userList, companyList] = await Promise.all([
      await Repositories.user.getList(),
      await Repositories.company.getList(),
    ])

    this.ownerUserList = userList.filter(user => user.roles.includes('OWNER'))
    this.companyList = companyList
  },
  methods: {
    change () {
      this.$emit('input', this.internalValue)
      this.$emit('validate', this.isValidUser)
    },
  },
  rules: {
    duplicateCompanyId: [
      FormRules.required('error.form.required'),
    ],
    companyLogin: [
      FormRules.required('error.form.required'),
      FormRules.minLength('error.form.minLength', { length: 2 }),
      FormRules.maxLength('error.form.maxLength', { length: 15 }),
      FormRules.noSpaces('error.form.noSpaces'),
    ],
    displayName: [
      FormRules.required('error.form.required'),
      FormRules.minLength('error.form.minLength', { length: 2 }),
    ],
    masterContactList: [
      FormRules.minLength('error.form.required', { length: 1 }),
    ],
  },
}
</script>
